module.exports = __webpack_public_path__ + "img/cca-java-level-1.4e3cbbaa.png";